import React from 'react';

import classNames from '../../../utils/classNames';
import Popup from '../../common/Popup';

type AttributionMode = 'geo' | 'performance';

interface AttributionChooserDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (mode: AttributionMode) => void;
  disabled?: boolean;
}

const options: Array<{
  mode: AttributionMode;
  title: string;
  description: string;
  hint: string;
}> = [
  {
    mode: 'geo',
    title: 'Attribution par localisation et CA cible',
    description: 'Optimisez la répartition des copropriétés selon les positions géographiques et les objectifs de chiffre d’affaires.',
    hint: 'Positionnez vos transactionnaires sur une carte pour optimiser la répartition des copropriétés.',
  },
  {
    mode: 'performance',
    title: 'Attribution par CA des copros / salariés',
    description: 'Classez vos meilleurs collaborateurs pour les grands comptes et distribuez les copropriétés à plus forte valeur en priorité.',
    hint: 'Affectation automatique selon votre classement des transactionnaires ',
  },
];

const AttributionChooserDialog = ({ isOpen, onClose, onSelect, disabled }: AttributionChooserDialogProps) => (
  <Popup
    isOpen={isOpen}
    onClose={() => {
      if (disabled) {
        return;
      }
      onClose();
    }}
    title="Choisir un mode d’attribution intelligente"
    additionalClass="w-full max-w-4xl"
    disableCloseButton={disabled}
  >
    <div className="grid gap-6 md:grid-cols-2">
      {options.map((option) => (
        <button
          key={option.mode}
          type="button"
          onClick={() => {
            if (disabled) {
              return;
            }
            onSelect(option.mode);
          }}
          className={classNames(
            'flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-rgpd-blue-light',
            disabled && 'cursor-not-allowed opacity-60',
          )}
          disabled={disabled}
        >
          <div>
            <h3 className="text-lg font-semibold text-gray-800">{option.title}</h3>
            <p className="mt-2 text-sm text-gray-600">{option.description}</p>
          </div>
          <p className="mt-auto text-xs font-medium text-rgpd-blue-light uppercase">{option.hint}</p>
        </button>
      ))}
    </div>
  </Popup>
);

export default AttributionChooserDialog;

